import * as React from 'react';
import DatePicker from "react-multi-date-picker"
import { Button, Typography } from '@mui/material';
import FechaData from '../../../../historial/Empleado/FechaData';
import "react-multi-date-picker/styles/colors/green.css"
import DatePanel from "react-multi-date-picker/plugins/date_panel"
import useSubmitLock from '../../../../../hooks/useSubmitLock';
const { REACT_APP_API_URL } = process.env;


export default function AltaFaltasInjustificadas(props) {
    const { lote } = props
    const { periodo } = props
    const { idempleado } = props
    const { activarbotontab } = props
    const { notificacion } = props
    const { idconcepto } = props
    const [datearray, setDatearray] = React.useState([''])
    const [dates, setDates] = React.useState([])

    const fechainicio = periodo.fechainicio + 1
    const fechafin = periodo.fechafin + 1

    const { obtenerdatolote } = props
    const { datotodoempleado } = props
    const { submitting, runWithSubmitLock } = useSubmitLock()


    const weekDays = ["Dom", "Lun", "Mar", "Mier", "Jue", "Vier", "Sab"]
    const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]

    const Addaltafestivo = () => runWithSubmitLock(async () => {
        const token = sessionStorage.getItem('%t')

        const resul = {
            variant: 'warning',
            msg: 'Debe seleccionar por lo menos una fecha'
        }

        if (datearray[0] === '' || idempleado === '') {
            notificacion(resul)

        } else {
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${token}`);
            myHeaders.append("Content-Type", "application/json");


            var raw = JSON.stringify({
                "idlote": lote,
                "idperiodo": periodo.idperiodo,
                "idempleado": idempleado,
                "codigoempleado": datotodoempleado.codigoempleado,
                "nombrelargo": datotodoempleado.nombrelargo,
                "idtipoincidencia": `${idconcepto}`,
                "fechas": datearray
            });

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            try {
                const response = await fetch(`${REACT_APP_API_URL}/pdim/incidencia`, requestOptions)
                const resultado = await response.json();



                return (notificacion(resultado), obtenerdatolote(lote), setDatearray({}), setDates({}))
            } catch (error) {
                console.log('Algo salio mal', error);
            }
        }
    })

    const handchange = (date) => {
        setDates(date);
        const fechastring = date.toString();
        setDatearray(typeof fechastring === 'string' ? fechastring.split(',') : fechastring,);
    };

    return (
        <div>
            <br />
            <br />
            Fechas:
            <br />
            <DatePicker
                weekDays={weekDays}
                months={months}
                mainPosition="top"
                fixMainPosition={true}
                calendarPosition={`top-center`}

                style={{
                    backgroundColor: "aliceblue",
                    height: "45px",
                    borderRadius: "3px",
                    fontSize: "16px",
                    padding: "3px 10px"
                }}
                disableYearPicker
                multiple
                className="green"
                value={dates}
                minDate={fechainicio}
                maxDate={fechafin}
                onChange={handchange}
                format="YYYY-MM-DD"
                sort
                plugins={[
                    <DatePanel />
                ]}
            />
            <br />
            <br />
            <Button variant='contained' disabled={submitting} onClick={() => Addaltafestivo()}>Agregar</Button>
        </div>
    );
}